<template>
  <v-skeleton-loader :loading="loading" transition="scale-transition" type="card">
    <v-card>
      <v-row class="my-0">
        <v-col  cols="12">
      <v-card-title v-if="percentDif > 0 && chartValues.length > 0">
        Total Inpatient
        <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ percentDif }}%</span>
      </v-card-title>
      <v-card-title v-if="percentDif < 0 && chartValues.length > 0">
        Total Inpatient
        <v-icon class="mdi mdi-arrow-up error--text mb-1" size="15"></v-icon>
        <span class="error--text">{{ Math.abs(percentDif) }}%</span>
      </v-card-title>
      <v-card-title v-if="percentDif === 0 && chartValues.length > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              Total Inpatient
              <v-icon class="mdi mdi-swap-vertical mb-1" size="15"></v-icon> -
            </span>
          </template>
          <span>Less than 1% change</span>
        </v-tooltip>
      </v-card-title>
      <v-card-title v-if="chartValues.length < 1">
        Total Inpatient
        <v-divider class="my-2"></v-divider>
        <v-alert type="info">No Data for selected input</v-alert>
      </v-card-title>
        </v-col>
      </v-row>
        <line-chart
          :data="dataCollection"
          :options="options"
          :styles="chartStyles"
          :chart="'totalInpatient'"
        />
     
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from "axios";
import LineChart from "../charts/LineChart";

export default {
  components: {
    LineChart
  },
  props: ["chartInfo", "view"],
  data: () => ({
    dataCollection: null,
    dashboardRange: null,
    chartMonths: [],
    chartValues: [],
    lineColor: "#7A49A5",
    percentDif: 0,
    loading: false,
    cancelSource: null,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: false,
              labelString: "Months"
            },
            gridLines: {
              color: "rgba(61, 97, 133, 0.25)",
              display: true,
              drawBorder: false,
              drawTicks: false
            },
            ticks: {
              padding: 10
            }
          }
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "Total Number of Inpatients by month"
            },
            gridLines: {
              display: false
            },
            ticks: {
              padding: 10
            }
          }
        ]
      }
    }
  }),
  mounted() {
    this.getData();
  },
  methods: {
    // Get  all patients
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];

      this.chartInfo.forEach(info => {
        this.chartMonths.push(info.month);
        this.chartValues.push(info['total inpatient']);
      });

      this.getPercentDif();
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1]
        ? this.chartValues[this.chartValues.length - 1]
        : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif =
        firstVal !== 0
          ? Math.ceil((decreaseValue / firstVal) * 100)
          : Math.ceil(decreaseValue * 100);

      this.loading = false;
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: "Total Inpatient",
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues
          }
        ]
      };

      // set max and min values for charts
      this.options.scales.yAxes[0].ticks.max = Math.max(...this.chartValues);
      if (!Math.min(...this.chartValues) == 0) {
        this.options.scales.yAxes[0].ticks.min = Math.min(...this.chartValues) - 0.005;
      } else {
        this.options.scales.yAxes[0].ticks.min = Math.min(...this.chartValues[-2]) - 0.005;
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    }
  },
  computed: {
    chartStyles() {
      if (this.view === "dashboard" || this.view === "dashboard top") {
        return {
          height: "30vh"
        };
      } else {
        return {
          height: "25vh"
        };
      }
    }
  },
  watch: {
    async chartValues() {
      this.chartData();
    },
    async chartInfo() {
      this.getData();
    },
     async dashboardRange() {
      this.$emit("dashboardRange", this.dashboardRange);
    }
  }
};
</script>

<style></style>